import { rmsConstants } from "./rmsConstants";

const rmsActions = {}

rmsActions.getRMSDetails = () => ({
    type: rmsConstants.RMS_SAGA
})

export { rmsActions };